// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =====================================================
   DATA EXPLORER DIALOG — BizMetry design system
   -----------------------------------------------------
   Header 68px · brand gradient · icon 30px (no box) · title 19/600 · subtitle 12px
   Footer 68px · white · 2px #f0f0f0 top border
   Buttons 36px · radius 4 · 13/600 · no uppercase, no lift
   Tags: brand-soft (rgba(102,126,234,.12) / #5568d3) · amber (#fef3c7 / #92400e)
   Text #2c3e50 / #555 / #888 · borders #e0e0e0 / #eef0f3
   JetBrains Mono only for identifiers and raw values
   ===================================================== */

.data-explorer-dialog {
    --de-gradient:     linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    --de-primary:      #667eea;
    --de-primary-dark: #5568d3;
    --de-primary-soft: rgba(102, 126, 234, .12);
    --de-primary-tint: rgba(102, 126, 234, .06);
    --de-text:         #2c3e50;
    --de-text-2:       #555;
    --de-muted:        #888;
    --de-faint:        #bbb;
    --de-border:       #e0e0e0;
    --de-border-soft:  #eef0f3;
    --de-page:         #fafbfc;
    --de-amber-bg:     #fef3c7;
    --de-amber:        #92400e;
    --de-danger:       #e53e3e;
    --de-mono:         'JetBrains Mono', 'Fira Code', monospace;
}

/* ── Dialog shell ── */
.data-explorer-dialog {
    width: 1440px;
    max-width: 98vw;
    height: 90vh;
    max-height: 90vh;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

/* ── Toolbar ── */
.de-toolbar {
    background: var(--de-gradient) !important;
    min-height: 68px !important;
    max-height: 68px !important;
    flex-shrink: 0 !important;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .15) !important;
}

.de-toolbar .md-toolbar-tools {
    height: 68px !important;
    min-height: 68px !important;
    padding: 0 16px 0 24px !important;
    gap: 14px !important;
    display: flex !important;
    align-items: center !important;
}

/* Icon: plain white glyph, no tile around it */
.de-toolbar-icon-wrap {
    display: flex;
    align-items: center;
    flex-shrink: 0;
}

.de-toolbar-icon-wrap md-icon {
    color: white !important;
    font-size: 30px !important;
    width: 30px !important;
    height: 30px !important;
    margin: 0 !important;
}

.de-toolbar-info {
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.de-toolbar-title {
    font-size: 19px;
    font-weight: 600;
    line-height: 1.2;
    color: white;
    letter-spacing: 0;
}

.de-toolbar-sub {
    font-size: 12px;
    color: rgba(255, 255, 255, .8);
    display: flex;
    align-items: center;
    gap: 6px;
}

.de-toolbar-host { font-family: var(--de-mono); font-size: 11px; }

.de-toolbar-sep { color: rgba(255, 255, 255, .45); }

.de-toolbar-type {
    background: rgba(255, 255, 255, .18);
    color: white;
    padding: 1px 7px;
    border-radius: 4px;
    font-size: 11px;
    font-weight: 600;
}

/* Header chips: white-on-gradient, square-ish like the rest of the tags */
.de-badge {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 4px 10px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 600;
    flex-shrink: 0;
    white-space: nowrap;
    background: rgba(255, 255, 255, .15);
    color: white;
    border: none;
}

.de-badge md-icon {
    font-size: 15px !important;
    width: 15px !important;
    height: 15px !important;
    margin: 0 !important;
    color: rgba(255, 255, 255, .85) !important;
}

.de-badge-table {
    font-family: var(--de-mono);
    font-weight: 500;
    max-width: 260px;
    overflow: hidden;
    text-overflow: ellipsis;
}

.de-close-btn {
    color: rgba(255, 255, 255, .8) !important;
    margin: 0 !important;
    width: 36px !important;
    height: 36px !important;
    min-width: 36px !important;
    border-radius: 50% !important;
}
.de-close-btn:hover { background: rgba(255, 255, 255, .12) !important; color: white !important; }
.de-close-btn md-icon { color: inherit !important; }

/* ── Body layout ── */
/* Angular Material sobrescribe md-dialog-content con display:block */
.de-body {
    flex: 1 !important;
    min-height: 0 !important;
    overflow: hidden !important;
    padding: 0 !important;
    display: flex !important;
    flex-direction: row !important;
    background: var(--de-page) !important;
}

/* ════════════════════════════════════════════════
   LEFT PANEL — tree
════════════════════════════════════════════════ */
.de-left-panel {
    width: 300px;
    min-width: 260px;
    max-width: 300px;
    flex-shrink: 0;
    background: #ffffff;
    border-right: 1px solid var(--de-border);
    display: flex;
    flex-direction: column;
    overflow: hidden;
    min-height: 0;
}

.de-panel-header {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px 14px 10px;
    border-bottom: 1px solid var(--de-border-soft);
    background: white;
    font-size: 12px;
    font-weight: 600;
    color: var(--de-text-2);
    text-transform: uppercase;
    letter-spacing: .4px;
    flex-shrink: 0;
}

.de-panel-header-icon {
    font-size: 16px !important; width: 16px !important; height: 16px !important;
    color: var(--de-primary) !important; margin: 0 !important;
}

.de-refresh-btn {
    width: 28px !important;
    height: 28px !important;
    min-width: 28px !important;
    min-height: 28px !important;
    padding: 0 !important;
    margin: 0 !important;
    color: var(--de-muted) !important;
}

.de-refresh-btn md-icon {
    font-size: 16px !important;
    width: 16px !important;
    height: 16px !important;
    color: var(--de-muted) !important;
}

/* ── Search input ── */
.de-tree-search {
    display: flex;
    align-items: center;
    gap: 6px;
    margin: 10px 12px;
    padding: 2px 4px 2px 10px;
    border: 1px solid var(--de-border);
    border-radius: 4px;
    background: white;
    flex-shrink: 0;
    transition: border-color .18s ease, box-shadow .18s ease;
}
.de-tree-search:focus-within { border-color: var(--de-primary); box-shadow: 0 0 0 3px rgba(102, 126, 234, .12); }

.de-tree-search md-icon {
    font-size: 16px !important;
    width: 16px !important;
    height: 16px !important;
    color: var(--de-muted) !important;
    margin: 0 !important;
    flex-shrink: 0;
}

.de-tree-search input {
    flex: 1;
    height: 28px;
    border: none;
    outline: none;
    font-size: 13px;
    color: var(--de-text);
    background: transparent;
    min-width: 0;
}

.de-tree-search .de-tree-search-clear {
    min-width: 24px !important; width: 24px !important; height: 24px !important; min-height: 24px !important;
    padding: 0 !important; margin: 0 !important; line-height: 24px !important;
}
.de-tree-search .de-tree-search-clear md-icon { font-size: 14px !important; width: 14px !important; height: 14px !important; }

.de-tree-search input::placeholder {
    color: #aaa;
}

.de-tree-loading,
.de-tree-error {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    padding: 40px 16px;
    color: var(--de-muted);
    font-size: 13px;
    text-align: center;
}

.de-tree-error { color: var(--de-danger); }

.de-tree-error md-icon {
    font-size: 36px !important;
    width: 36px !important;
    height: 36px !important;
}

.de-tree-error md-icon { color: var(--de-danger) !important; }

/* ── Tree scroll area ── */
.de-tree-scroll {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
}

.de-tree-scroll::-webkit-scrollbar { width: 5px; }

.de-tree-scroll::-webkit-scrollbar-thumb {
    background: #e0e0e0;
    border-radius: 3px;
}

.de-tree-scroll::-webkit-scrollbar-thumb:hover { background: #bdbdbd; }

/* ── Schema rows ── */
.de-schema-block { border-bottom: 1px solid var(--de-border-soft); }

.de-schema-row {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 9px 10px 9px 8px;
    cursor: pointer;
    user-select: none;
    transition: background 0.15s ease;
}

.de-schema-row:hover        { background: var(--de-primary-tint); }
.de-schema-row-expanded     { background: var(--de-primary-tint); }

.de-schema-name {
    flex: 1;
    font-size: 13px;
    font-weight: 600;
    color: var(--de-text);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.de-schema-icon {
    font-size: 16px !important;
    width: 16px !important;
    height: 16px !important;
    color: var(--de-primary) !important;
    flex-shrink: 0;
}

.de-table-count-badge {
    background: var(--de-primary-soft);
    color: var(--de-primary-dark);
    font-size: 11px;
    font-weight: 600;
    padding: 1px 6px;
    border-radius: 4px;
    flex-shrink: 0;
}

/* ── Chevron ── */
.de-chevron {
    font-size: 18px !important;
    width: 18px !important;
    height: 18px !important;
    color: var(--de-faint) !important;
    flex-shrink: 0;
    transition: transform 0.2s ease;
}

.de-chevron-sm {
    font-size: 14px !important;
    width: 14px !important;
    height: 14px !important;
}

.de-chevron-open { transform: rotate(90deg); }

/* ── Tables / attributes ── */
.de-subtree-loading,
.de-subtree-empty {
    padding: 6px 12px 6px 44px;
    font-size: 12px;
    color: var(--de-muted);
}

.de-table-row {
    display: flex;
    align-items: center;
    gap: 5px;
    padding: 7px 10px 7px 18px;
    cursor: pointer;
    user-select: none;
    transition: background 0.15s ease;
}

.de-table-row:hover { background: var(--de-primary-tint); }

.de-table-row-selected {
    background: var(--de-primary-soft) !important;
    border-left: 3px solid var(--de-primary);
    padding-left: 15px !important;
}

.de-table-expand-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    min-width: 18px;
    flex-shrink: 0;
}

.de-table-icon {
    font-size: 15px !important;
    width: 15px !important;
    height: 15px !important;
    color: var(--de-muted) !important;
    flex-shrink: 0;
    transition: color 0.15s;
}

.de-table-icon-selected { color: var(--de-primary) !important; }

.de-table-name {
    flex: 1;
    font-size: 13px;
    color: var(--de-text);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.de-table-row-selected .de-table-name {
    color: var(--de-primary-dark);
    font-weight: 600;
}

.de-attr-row {
    display: flex;
    align-items: center;
    gap: 5px;
    padding: 4px 10px 4px 48px;
    transition: background 0.12s;
}

.de-attr-row:hover { background: var(--de-page); }

.de-attr-icon {
    font-size: 13px !important;
    width: 13px !important;
    height: 13px !important;
    flex-shrink: 0;
}

.de-attr-name {
    font-size: 12px;
    color: var(--de-text-2);
    flex: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    transition: opacity 0.15s, text-decoration 0.15s;
}

.de-attr-type {
    font-size: 10px;
    color: var(--de-muted);
    font-family: var(--de-mono);
    background: #f5f5f5;
    padding: 1px 5px;
    border-radius: 4px;
    flex-shrink: 0;
    max-width: 80px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    transition: opacity 0.15s;
}

/* PK: amber tag */
.de-pk-badge {
    font-size: 10px;
    font-weight: 600;
    color: var(--de-amber);
    background: var(--de-amber-bg);
    padding: 0 5px;
    border-radius: 4px;
    flex-shrink: 0;
}

/* ── Type icon colors ── */
.de-type-num  { color: #1565c0 !important; }
.de-type-str  { color: #2e7d32 !important; }
.de-type-date { color: #6a1b9a !important; }
.de-type-bool { color: #e65100 !important; }
.de-type-json { color: #00695c !important; }
.de-type-id   { color: #c62828 !important; }
.de-type-bin  { color: #4e342e !important; }

/* ════════════════════════════════════════════════
   RIGHT PANEL — data viewer
   min-height:0 es obligatorio en cada nivel de la
   cadena flex para que justify-content:center funcione
════════════════════════════════════════════════ */
.de-right-panel {
    flex: 1 !important;
    min-width: 0 !important;
    min-height: 0 !important;
    display: flex !important;
    flex-direction: column !important;
    overflow: hidden !important;
    background: var(--de-page);
}

/* Wrapper interno generado por ng-if="selectedTable" */
.de-right-panel > div {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

/* State icon (no table / no rows / no matches / error) */
.de-state-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 56px;
    height: 56px;
    border-radius: 50%;
    background: var(--de-primary-soft);
    margin-bottom: 4px;
}

.de-state-icon md-icon {
    font-size: 28px !important;
    width: 28px !important;
    height: 28px !important;
    color: var(--de-muted) !important;
    margin: 0 !important;
}

.de-state-icon--error { background: rgba(229, 62, 62, .1); }
.de-state-icon--error md-icon { color: var(--de-danger) !important; }

.de-state-title { font-size: 15px; font-weight: 600; color: var(--de-text); }
.de-state-sub   { font-size: 13px; color: var(--de-muted); }

/* ── Data wrapper & content area ── */
.de-data-wrapper,
.de-data-content-area {
    flex: 1 !important;
    min-width: 0 !important;
    min-height: 0 !important;
    display: flex !important;
    flex-direction: column !important;
    overflow: hidden !important;
}

/* ── Data header bar ── */
.de-data-header {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 10px 16px;
    background: white;
    border-bottom: 1px solid var(--de-border-soft);
    flex-shrink: 0 !important;
    flex-wrap: wrap;
}

.de-data-breadcrumb {
    display: flex;
    align-items: center;
    gap: 6px;
}

.de-bc-icon { font-size: 16px !important; width: 16px !important; height: 16px !important; color: var(--de-primary) !important; margin: 0 !important; }
.de-bc-sep  { font-size: 14px !important; width: 14px !important; height: 14px !important; color: var(--de-faint) !important; margin: 0 !important; }

.de-bc-schema {
    font-family: var(--de-mono);
    font-size: 12px;
    color: var(--de-primary-dark);
    font-weight: 500;
}

.de-bc-table {
    font-family: var(--de-mono);
    font-size: 13px;
    font-weight: 600;
    color: var(--de-text);
}

.de-pagination-info {
    font-size: 12px;
    color: var(--de-muted);
    white-space: nowrap;
    flex-shrink: 0;
}

.de-page-size-wrap {
    display: flex;
    align-items: center;
    gap: 6px;
    flex-shrink: 0;
}

.de-page-size-label {
    font-size: 12px;
    color: var(--de-muted);
}

.de-page-size-select {
    border: 1px solid var(--de-border);
    border-radius: 4px;
    padding: 3px 7px;
    font-size: 12px;
    color: var(--de-text);
    background: white;
    cursor: pointer;
    outline: none;
}

.de-page-size-select:focus { border-color: var(--de-primary); }

.de-pagination-btns {
    display: flex;
    align-items: center;
    gap: 2px;
    flex-shrink: 0;
}

.de-pag-btn {
    width: 30px !important;
    height: 30px !important;
    min-width: 30px !important;
    min-height: 30px !important;
    padding: 0 !important;
    margin: 0 !important;
    color: var(--de-text-2) !important;
    border-radius: 4px !important;
    line-height: 30px !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
}

.de-pag-btn md-icon {
    font-size: 18px !important;
    width: 18px !important;
    height: 18px !important;
    line-height: 18px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
}

.de-pag-btn[disabled]            { opacity: 0.35 !important; }
.de-pag-btn:not([disabled]):hover { background: var(--de-primary-tint) !important; color: var(--de-primary) !important; }

.de-page-num {
    font-size: 12px;
    color: var(--de-text-2);
    font-weight: 600;
    padding: 0 8px;
    white-space: nowrap;
}

/* ── Loading / error / empty data states ── */
.de-data-loading,
.de-data-err,
.de-data-no-rows {
    flex: 1 !important;
    min-width: 0 !important;
    min-height: 0 !important;
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
    justify-content: center !important;
    text-align: center !important;
    padding: 40px !important;
    gap: 10px;
    font-size: 13px;
    color: var(--de-muted);
}

.de-data-err { gap: 10px; }

/* ── Data table wrapper ── */
.de-table-scroll-wrap {
    flex: 1 !important;
    min-width: 0 !important;
    min-height: 0 !important;
    overflow: auto;
}

.de-table-scroll-wrap::-webkit-scrollbar        { width: 8px; height: 8px; }
.de-table-scroll-wrap::-webkit-scrollbar-thumb  { background: var(--de-border); border-radius: 4px; }
.de-table-scroll-wrap::-webkit-scrollbar-thumb:hover { background: var(--de-faint); }
.de-table-scroll-wrap::-webkit-scrollbar-corner { background: transparent; }

/* ── Data table ── */
.de-data-table {
    width: max-content;
    min-width: 100%;
    border-collapse: collapse;
    font-size: 13px;
}

.de-data-table thead {
    position: sticky;
    top: 0;
    z-index: 10;
}

.de-row-num-th {
    position: sticky;
    left: 0;
    z-index: 11;
    width: 52px;
    min-width: 52px;
    padding: 10px 8px;
    text-align: right;
    font-size: 11px;
    font-weight: 600;
    color: var(--de-muted);
    background: #f5f6f8;
    border-bottom: 1px solid var(--de-border);
    border-right: 1px solid var(--de-border-soft);
    user-select: none;
}

.de-col-th {
    padding: 10px 14px !important;
    background: #f5f6f8 !important;
    border-bottom: 1px solid var(--de-border) !important;
    border-right: 1px solid var(--de-border-soft) !important;
    font-size: 12px !important;
    font-weight: 600 !important;
    color: var(--de-text-2) !important;
    white-space: nowrap !important;
    user-select: none !important;
    text-align: left !important;
    vertical-align: middle !important;
}

.de-col-th-inner {
    display: inline-flex !important;
    align-items: center !important;
    justify-content: flex-start !important;
    gap: 6px !important;
    width: auto !important;
    min-width: 0 !important;
    margin: 0 !important;
    padding: 0 !important;
    box-sizing: border-box !important;
    text-align: left !important;
    line-height: 1.2 !important;
}

.de-col-th-inner span {
    text-align: left !important;
}

.de-col-type-icon {
    font-size: 13px !important;
    width: 13px !important;
    height: 13px !important;
    flex: 0 0 auto !important;
    margin-right: 2px !important;
}

/* ── Rows ── */
.de-data-row { transition: background 0.1s ease; }
.de-data-row:hover { background: var(--de-primary-tint) !important; }
.de-row-even { background: var(--de-page); }

.de-row-num-td {
    position: sticky;
    left: 0;
    z-index: 5;
    width: 52px;
    min-width: 52px;
    padding: 8px;
    text-align: right;
    font-size: 11px;
    color: var(--de-faint);
    background: inherit;
    border-right: 1px solid var(--de-border-soft);
    border-bottom: 1px solid var(--de-border-soft);
    font-family: var(--de-mono);
}

.de-data-td {
    padding: 10px 14px !important;
    text-align: left !important;
    vertical-align: middle !important;
    border-bottom: 1px solid var(--de-border-soft);
    border-right: 1px solid var(--de-border-soft);
    max-width: 320px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* ── Cell value types ── */
.de-null-val {
    color: var(--de-faint);
    font-size: 11px;
    font-family: var(--de-mono);
}

.de-cell-val { color: var(--de-text); }

.de-val-num {
    color: #1565c0;
    font-family: var(--de-mono);
    font-size: 12px;
}

.de-val-id {
    color: var(--de-primary-dark);
    font-family: var(--de-mono);
    font-size: 11px;
    background: var(--de-primary-soft);
    padding: 1px 5px;
    border-radius: 4px;
}

.de-val-date {
    color: #4a148c;
    font-family: var(--de-mono);
    font-size: 12px;
}

.de-val-bool {
    color: var(--de-amber);
    font-weight: 600;
    font-size: 12px;
}

.de-val-json {
    color: #00695c;
    font-family: var(--de-mono);
    font-size: 11px;
}

/* ── Spinners ── */
.de-spinner circle { stroke: var(--de-primary) !important; }

.de-inline-spinner {
    flex-shrink: 0;
    margin-left: auto;
}

.de-inline-spinner circle { stroke: var(--de-muted) !important; }

.de-spin { animation: de-spin-anim 0.8s linear infinite; }

/* ── Explorer action button (datasource table) ── */
.action-icon-explorer { color: var(--de-primary, #667eea) !important; }

/* ── Animations ── */
@keyframes de-spin-anim {
    from { transform: rotate(0deg); }
    to   { transform: rotate(360deg); }
}

.de-table-expand-btn .de-chevron {
    width: 14px !important;
    height: 14px !important;
    display: flex !important;
    align-items: center;
    justify-content: center;
}

.de-right-panel {
    display: flex !important;
    flex-direction: column !important;
    flex: 1 !important;
    min-height: 0 !important;
}

.de-data-wrapper {
    display: flex !important;
    flex-direction: column !important;
    flex: 1 !important;
    min-height: 0 !important;
}

.de-data-content-area {
    display: flex !important;
    flex-direction: column !important;
    flex: 1 !important;
    min-height: 0 !important;
}

/* ════════════════════════════════════════════════
   COLUMN VISIBILITY CHECKBOXES
════════════════════════════════════════════════ */

/* Checkbox de visibilidad en cada fila de atributo */
.de-attr-checkbox {
    width: 13px;
    height: 13px;
    min-width: 13px;
    cursor: pointer;
    accent-color: var(--de-primary);
    flex-shrink: 0;
    margin: 0;
}

/* Atributo oculto → tachado y opaco */
.de-attr-row-hidden .de-attr-name {
    opacity: 0.38;
    text-decoration: line-through;
}

.de-attr-row-hidden .de-attr-type,
.de-attr-row-hidden .de-attr-icon,
.de-attr-row-hidden .de-pk-badge {
    opacity: 0.35;
}

/* Botón toggle-all en la fila de la tabla */
.de-col-toggle-btn {
    width: 20px !important;
    height: 20px !important;
    min-width: 20px !important;
    min-height: 20px !important;
    padding: 0 !important;
    margin: 0 0 0 2px !important;
    flex-shrink: 0;
    color: var(--de-faint) !important;
    border-radius: 4px !important;
    line-height: 20px !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
}

.de-col-toggle-btn:hover {
    background: var(--de-primary-soft) !important;
    color: var(--de-primary) !important;
}

.de-col-toggle-wrap { display: inline-flex; align-items: center; gap: 3px; margin-left: 2px; flex-shrink: 0; }

.de-col-toggle-btn md-icon {
    font-size: 13px !important;
    width: 13px !important;
    height: 13px !important;
}

/* Badge "N/M cols" cuando hay columnas ocultas */
/* "N/M" visible columns: amber while some are hidden, brand-soft when all are shown */
.de-col-vis-badge {
    font-size: 10px;
    font-weight: 600;
    padding: 1px 5px;
    border-radius: 4px;
    flex-shrink: 0;
    white-space: nowrap;
    background: var(--de-amber-bg);
    color: var(--de-amber);
}

.de-col-vis-badge-full {
    background: var(--de-primary-soft);
    color: var(--de-primary-dark);
}
/* ════════════════════════════════════════════════
   DATA SEARCH (server-side)
   Own de-* classes: agents-tab.css defines unscoped .search-icon / .search-input
════════════════════════════════════════════════ */
.de-data-search-bar {
    padding: 10px 16px;
    background: white;
    border-bottom: 1px solid var(--de-border-soft);
    flex-shrink: 0 !important;
}

.de-data-search {
    display: flex;
    align-items: center;
    gap: 8px;
    max-width: 520px;
    padding: 4px 8px 4px 12px;
    background: white;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    transition: border-color .18s ease, box-shadow .18s ease;
}
.de-data-search:focus-within {
    border-color: #667eea;
    box-shadow: 0 0 0 3px rgba(102, 126, 234, .12);
}

.de-data-search-icon {
    font-size: 18px !important; width: 18px !important; height: 18px !important;
    color: #888 !important; margin: 0 !important; flex-shrink: 0;
}

.de-data-search .de-data-search-input {
    flex: 1;
    min-width: 0;
    height: 26px;
    border: none !important;
    outline: none !important;
    box-shadow: none !important;
    background: transparent !important;
    padding: 0 !important;
    font-size: 13px;
    color: #2c3e50;
}
.de-data-search-input::placeholder { color: #aaa; }

.de-data-search .de-data-search-clear {
    margin: 0 !important; padding: 0 !important;
    min-width: 24px !important; width: 24px !important; height: 24px !important; min-height: 24px !important;
    line-height: 24px !important; flex-shrink: 0;
}
.de-data-search .de-data-search-clear md-icon {
    font-size: 16px !important; width: 16px !important; height: 16px !important; color: #888 !important; margin: 0 !important;
}

.de-no-match-term {
    font-family: var(--de-mono);
    font-weight: 500; font-size: 13px;
    padding: 2px 8px; border-radius: 4px;
    background: var(--de-primary-soft); color: var(--de-primary-dark);
    word-break: break-all;
}

/* ════════════════════════════════════════════════
   FOOTER + BUTTONS (36px · radius 4 · 13/600)
════════════════════════════════════════════════ */
.data-explorer-dialog .de-footer {
    background: white !important;
    border-top: 2px solid #f0f0f0 !important;
    box-shadow: none !important;
    min-height: 68px !important;
    padding: 14px 24px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: flex-end !important;
    gap: 12px !important;
    flex-shrink: 0 !important;
}

.data-explorer-dialog .de-btn-neutral,
.data-explorer-dialog .de-btn-secondary {
    height: 36px !important; min-height: 36px !important; line-height: 36px !important;
    padding: 0 18px !important; margin: 0 !important;
    border-radius: 4px !important;
    font-size: 13px !important; font-weight: 600 !important;
    text-transform: none !important; letter-spacing: 0 !important;
    display: inline-flex !important; align-items: center !important; justify-content: center !important; gap: 6px !important;
    box-shadow: none !important; transform: none !important;
    transition: background .18s ease !important;
}
.data-explorer-dialog .de-btn-neutral md-icon,
.data-explorer-dialog .de-btn-secondary md-icon {
    font-size: 18px !important; width: 18px !important; height: 18px !important; min-height: 18px !important;
    margin: 0 !important; color: inherit !important;
}

/* neutral — Close */
.data-explorer-dialog .de-btn-neutral { background: #f5f5f5 !important; color: #666 !important; border: 1px solid var(--de-border) !important; }
.data-explorer-dialog .de-btn-neutral:hover { background: #eaeaea !important; }

/* secondary — Retry / Clear search */
.data-explorer-dialog .de-btn-secondary { background: white !important; color: var(--de-primary) !important; border: 2px solid var(--de-primary) !important; }
.data-explorer-dialog .de-btn-secondary:hover { background: var(--de-primary-tint) !important; }

/* ════════════════════════════════════════════════
   JSON CELLS → biz-json-viewer
════════════════════════════════════════════════ */
.de-json-cell {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    max-width: 290px;
    height: 24px;
    padding: 0 8px;
    margin: 0;
    border: 1px solid transparent;
    border-radius: 4px;
    background: var(--de-primary-tint);
    color: var(--de-primary-dark);
    font-family: var(--de-mono);
    font-size: 11px;
    cursor: pointer;
    transition: border-color .18s ease, background .18s ease;
}
.de-json-cell:hover { border-color: var(--de-primary); background: var(--de-primary-soft); }
.de-json-cell span { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.de-json-cell md-icon {
    font-size: 15px !important; width: 15px !important; height: 15px !important; min-width: 15px !important;
    color: var(--de-primary) !important; margin: 0 !important;
}

.de-json-backdrop {
    position: fixed;
    inset: 0;
    z-index: 9999;
    background: rgba(0, 0, 0, .55);
    display: flex;
    align-items: center;
    justify-content: center;
}
.de-json-frame {
    width: 90vw;
    max-width: 860px;
    height: 80vh;
    max-height: 80vh;
    border-radius: 8px;
    overflow: hidden;
    background: white;
    box-shadow: 0 24px 48px rgba(0, 0, 0, .4);
    display: flex;
    flex-direction: column;
}
.de-json-frame > biz-json-viewer {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    min-height: 0;
}
`, "",{"version":3,"sources":["webpack://./home/main-menu/data-explorer/data-explorer-dialog.css"],"names":[],"mappings":"AAAA;;;;;;;;;0DAS0D;;AAE1D;IACI,oEAAoE;IACpE,0BAA0B;IAC1B,0BAA0B;IAC1B,2CAA2C;IAC3C,2CAA2C;IAC3C,0BAA0B;IAC1B,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,0BAA0B;IAC1B,0BAA0B;IAC1B,0BAA0B;IAC1B,0BAA0B;IAC1B,0BAA0B;IAC1B,0BAA0B;IAC1B,2DAA2D;AAC/D;;AAEA,uBAAuB;AACvB;IACI,aAAa;IACb,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA,kBAAkB;AAClB;IACI,yCAAyC;IACzC,2BAA2B;IAC3B,2BAA2B;IAC3B,yBAAyB;IACzB,mDAAmD;AACvD;;AAEA;IACI,uBAAuB;IACvB,2BAA2B;IAC3B,iCAAiC;IACjC,oBAAoB;IACpB,wBAAwB;IACxB,8BAA8B;AAClC;;AAEA,+CAA+C;AAC/C;IACI,aAAa;IACb,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,uBAAuB;IACvB,0BAA0B;IAC1B,sBAAsB;IACtB,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA,mBAAmB,2BAA2B,EAAE,eAAe,EAAE;;AAEjE,kBAAkB,+BAA+B,EAAE;;AAEnD;IACI,oCAAoC;IACpC,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA,0EAA0E;AAC1E;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,oCAAoC;IACpC,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,0BAA0B;IAC1B,sBAAsB;IACtB,uBAAuB;IACvB,oBAAoB;IACpB,0CAA0C;AAC9C;;AAEA;IACI,2BAA2B;IAC3B,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,yCAAyC;IACzC,oBAAoB;IACpB,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;IAC1B,6BAA6B;AACjC;AACA,sBAAsB,+CAA+C,EAAE,uBAAuB,EAAE;AAChG,wBAAwB,yBAAyB,EAAE;;AAEnD,sBAAsB;AACtB,qEAAqE;AACrE;IACI,kBAAkB;IAClB,wBAAwB;IACxB,2BAA2B;IAC3B,qBAAqB;IACrB,wBAAwB;IACxB,8BAA8B;IAC9B,qCAAqC;AACzC;;AAEA;;kDAEkD;AAClD;IACI,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,wCAAwC;IACxC,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,uBAAuB;IACvB,8CAA8C;IAC9C,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,yBAAyB;IACzB,oBAAoB;IACpB,cAAc;AAClB;;AAEA;IACI,0BAA0B,EAAE,sBAAsB,EAAE,uBAAuB;IAC3E,mCAAmC,EAAE,oBAAoB;AAC7D;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;IAC1B,2BAA2B;IAC3B,qBAAqB;IACrB,oBAAoB;IACpB,iCAAiC;AACrC;;AAEA;IACI,0BAA0B;IAC1B,sBAAsB;IACtB,uBAAuB;IACvB,iCAAiC;AACrC;;AAEA,uBAAuB;AACvB;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,yBAAyB;IACzB,kCAAkC;IAClC,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,wDAAwD;AAC5D;AACA,+BAA+B,+BAA+B,EAAE,8CAA8C,EAAE;;AAEhH;IACI,0BAA0B;IAC1B,sBAAsB;IACtB,uBAAuB;IACvB,iCAAiC;IACjC,oBAAoB;IACpB,cAAc;AAClB;;AAEA;IACI,OAAO;IACP,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,eAAe;IACf,qBAAqB;IACrB,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,0BAA0B,EAAE,sBAAsB,EAAE,uBAAuB,EAAE,2BAA2B;IACxG,qBAAqB,EAAE,oBAAoB,EAAE,4BAA4B;AAC7E;AACA,gDAAgD,0BAA0B,EAAE,sBAAsB,EAAE,uBAAuB,EAAE;;AAE7H;IACI,WAAW;AACf;;AAEA;;IAEI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;IACf,kBAAkB;AACtB;;AAEA,iBAAiB,uBAAuB,EAAE;;AAE1C;IACI,0BAA0B;IAC1B,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA,yBAAyB,kCAAkC,EAAE;;AAE7D,2BAA2B;AAC3B;IACI,OAAO;IACP,aAAa;IACb,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA,qCAAqC,UAAU,EAAE;;AAEjD;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA,iDAAiD,mBAAmB,EAAE;;AAEtE,sBAAsB;AACtB,mBAAmB,8CAA8C,EAAE;;AAEnE;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,yBAAyB;IACzB,eAAe;IACf,iBAAiB;IACjB,iCAAiC;AACrC;;AAEA,8BAA8B,kCAAkC,EAAE;AAClE,8BAA8B,kCAAkC,EAAE;;AAElE;IACI,OAAO;IACP,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,0BAA0B;IAC1B,sBAAsB;IACtB,uBAAuB;IACvB,mCAAmC;IACnC,cAAc;AAClB;;AAEA;IACI,kCAAkC;IAClC,6BAA6B;IAC7B,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;AAClB;;AAEA,kBAAkB;AAClB;IACI,0BAA0B;IAC1B,sBAAsB;IACtB,uBAAuB;IACvB,iCAAiC;IACjC,cAAc;IACd,+BAA+B;AACnC;;AAEA;IACI,0BAA0B;IAC1B,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA,mBAAmB,wBAAwB,EAAE;;AAE7C,8BAA8B;AAC9B;;IAEI,0BAA0B;IAC1B,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,0BAA0B;IAC1B,eAAe;IACf,iBAAiB;IACjB,iCAAiC;AACrC;;AAEA,sBAAsB,kCAAkC,EAAE;;AAE1D;IACI,6CAA6C;IAC7C,wCAAwC;IACxC,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,0BAA0B;IAC1B,sBAAsB;IACtB,uBAAuB;IACvB,iCAAiC;IACjC,cAAc;IACd,uBAAuB;AAC3B;;AAEA,0BAA0B,mCAAmC,EAAE;;AAE/D;IACI,OAAO;IACP,eAAe;IACf,qBAAqB;IACrB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,0BAA0B;IAC1B,4BAA4B;AAChC;;AAEA,qBAAqB,0BAA0B,EAAE;;AAEjD;IACI,0BAA0B;IAC1B,sBAAsB;IACtB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,uBAAuB;IACvB,OAAO;IACP,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,gDAAgD;AACpD;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,2BAA2B;IAC3B,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA,kBAAkB;AAClB;IACI,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,8BAA8B;IAC9B,cAAc;IACd,kBAAkB;IAClB,cAAc;AAClB;;AAEA,2BAA2B;AAC3B,gBAAgB,yBAAyB,EAAE;AAC3C,gBAAgB,yBAAyB,EAAE;AAC3C,gBAAgB,yBAAyB,EAAE;AAC3C,gBAAgB,yBAAyB,EAAE;AAC3C,gBAAgB,yBAAyB,EAAE;AAC3C,gBAAgB,yBAAyB,EAAE;AAC3C,gBAAgB,yBAAyB,EAAE;;AAE3C;;;;kDAIkD;AAClD;IACI,kBAAkB;IAClB,uBAAuB;IACvB,wBAAwB;IACxB,wBAAwB;IACxB,iCAAiC;IACjC,2BAA2B;IAC3B,0BAA0B;AAC9B;;AAEA,uDAAuD;AACvD;IACI,OAAO;IACP,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA,yDAAyD;AACzD;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kCAAkC;IAClC,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;IAC1B,sBAAsB;IACtB,uBAAuB;IACvB,iCAAiC;IACjC,oBAAoB;AACxB;;AAEA,wBAAwB,iCAAiC,EAAE;AAC3D,gCAAgC,kCAAkC,EAAE;;AAEpE,kBAAkB,eAAe,EAAE,gBAAgB,EAAE,qBAAqB,EAAE;AAC5E,kBAAkB,eAAe,EAAE,sBAAsB,EAAE;;AAE3D,sCAAsC;AACtC;;IAEI,kBAAkB;IAClB,uBAAuB;IACvB,wBAAwB;IACxB,wBAAwB;IACxB,iCAAiC;IACjC,2BAA2B;AAC/B;;AAEA,0BAA0B;AAC1B;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,iBAAiB;IACjB,8CAA8C;IAC9C,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA,cAAc,0BAA0B,EAAE,sBAAsB,EAAE,uBAAuB,EAAE,mCAAmC,EAAE,oBAAoB,EAAE;AACtJ,cAAc,0BAA0B,EAAE,sBAAsB,EAAE,uBAAuB,EAAE,iCAAiC,EAAE,oBAAoB,EAAE;;AAEpJ;IACI,2BAA2B;IAC3B,eAAe;IACf,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;IAC3B,eAAe;IACf,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,qBAAqB;IACrB,iBAAiB;IACjB,eAAe;IACf,aAAa;AACjB;;AAEA,6BAA6B,+BAA+B,EAAE;;AAE9D;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,cAAc;AAClB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;IAC1B,2BAA2B;IAC3B,qBAAqB;IACrB,oBAAoB;IACpB,kCAAkC;IAClC,6BAA6B;IAC7B,4BAA4B;IAC5B,+BAA+B;IAC/B,8BAA8B;IAC9B,kCAAkC;AACtC;;AAEA;IACI,0BAA0B;IAC1B,sBAAsB;IACtB,uBAAuB;IACvB,4BAA4B;IAC5B,wBAAwB;IACxB,8BAA8B;IAC9B,kCAAkC;AACtC;;AAEA,mCAAmC,wBAAwB,EAAE;AAC7D,oCAAoC,6CAA6C,EAAE,mCAAmC,EAAE;;AAExH;IACI,eAAe;IACf,uBAAuB;IACvB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA,8CAA8C;AAC9C;;;IAGI,kBAAkB;IAClB,uBAAuB;IACvB,wBAAwB;IACxB,wBAAwB;IACxB,iCAAiC;IACjC,8BAA8B;IAC9B,kCAAkC;IAClC,6BAA6B;IAC7B,wBAAwB;IACxB,SAAS;IACT,eAAe;IACf,sBAAsB;AAC1B;;AAEA,eAAe,SAAS,EAAE;;AAE1B,6BAA6B;AAC7B;IACI,kBAAkB;IAClB,uBAAuB;IACvB,wBAAwB;IACxB,cAAc;AAClB;;AAEA,kDAAkD,UAAU,EAAE,WAAW,EAAE;AAC3E,kDAAkD,4BAA4B,EAAE,kBAAkB,EAAE;AACpG,uDAAuD,2BAA2B,EAAE;AACpF,kDAAkD,uBAAuB,EAAE;;AAE3E,qBAAqB;AACrB;IACI,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,MAAM;IACN,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,OAAO;IACP,WAAW;IACX,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB,yCAAyC;IACzC,6CAA6C;IAC7C,iBAAiB;AACrB;;AAEA;IACI,6BAA6B;IAC7B,8BAA8B;IAC9B,oDAAoD;IACpD,wDAAwD;IACxD,0BAA0B;IAC1B,2BAA2B;IAC3B,kCAAkC;IAClC,8BAA8B;IAC9B,4BAA4B;IAC5B,2BAA2B;IAC3B,iCAAiC;AACrC;;AAEA;IACI,+BAA+B;IAC/B,8BAA8B;IAC9B,sCAAsC;IACtC,mBAAmB;IACnB,sBAAsB;IACtB,uBAAuB;IACvB,oBAAoB;IACpB,qBAAqB;IACrB,iCAAiC;IACjC,2BAA2B;IAC3B,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,0BAA0B;IAC1B,sBAAsB;IACtB,uBAAuB;IACvB,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA,eAAe;AACf,eAAe,gCAAgC,EAAE;AACjD,qBAAqB,6CAA6C,EAAE;AACpE,eAAe,0BAA0B,EAAE;;AAE3C;IACI,gBAAgB;IAChB,OAAO;IACP,UAAU;IACV,WAAW;IACX,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,sBAAsB;IACtB,mBAAmB;IACnB,6CAA6C;IAC7C,8CAA8C;IAC9C,2BAA2B;AAC/B;;AAEA;IACI,6BAA6B;IAC7B,2BAA2B;IAC3B,iCAAiC;IACjC,8CAA8C;IAC9C,6CAA6C;IAC7C,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA,2BAA2B;AAC3B;IACI,sBAAsB;IACtB,eAAe;IACf,2BAA2B;AAC/B;;AAEA,eAAe,qBAAqB,EAAE;;AAEtC;IACI,cAAc;IACd,2BAA2B;IAC3B,eAAe;AACnB;;AAEA;IACI,6BAA6B;IAC7B,2BAA2B;IAC3B,eAAe;IACf,kCAAkC;IAClC,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,2BAA2B;IAC3B,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,2BAA2B;IAC3B,eAAe;AACnB;;AAEA,mBAAmB;AACnB,qBAAqB,oCAAoC,EAAE;;AAE3D;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA,4BAA4B,kCAAkC,EAAE;;AAEhE,WAAW,4CAA4C,EAAE;;AAEzD,oDAAoD;AACpD,wBAAwB,4CAA4C,EAAE;;AAEtE,qBAAqB;AACrB;IACI,OAAO,uBAAuB,EAAE;IAChC,OAAO,yBAAyB,EAAE;AACtC;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,wBAAwB;IACxB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,wBAAwB;IACxB,iCAAiC;IACjC,kBAAkB;IAClB,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;IACxB,iCAAiC;IACjC,kBAAkB;IAClB,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;IACxB,iCAAiC;IACjC,kBAAkB;IAClB,wBAAwB;AAC5B;;AAEA;;kDAEkD;;AAElD,qDAAqD;AACrD;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,eAAe;IACf,+BAA+B;IAC/B,cAAc;IACd,SAAS;AACb;;AAEA,sCAAsC;AACtC;IACI,aAAa;IACb,6BAA6B;AACjC;;AAEA;;;IAGI,aAAa;AACjB;;AAEA,4CAA4C;AAC5C;IACI,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;IAC1B,2BAA2B;IAC3B,qBAAqB;IACrB,4BAA4B;IAC5B,cAAc;IACd,iCAAiC;IACjC,6BAA6B;IAC7B,4BAA4B;IAC5B,+BAA+B;IAC/B,8BAA8B;IAC9B,kCAAkC;AACtC;;AAEA;IACI,6CAA6C;IAC7C,mCAAmC;AACvC;;AAEA,sBAAsB,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE,gBAAgB,EAAE,cAAc,EAAE;;AAE7G;IACI,0BAA0B;IAC1B,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA,iDAAiD;AACjD,sFAAsF;AACtF;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,8BAA8B;IAC9B,sBAAsB;AAC1B;;AAEA;IACI,kCAAkC;IAClC,6BAA6B;AACjC;AACA;;;kDAGkD;AAClD;IACI,kBAAkB;IAClB,iBAAiB;IACjB,8CAA8C;IAC9C,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,yBAAyB;IACzB,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,wDAAwD;AAC5D;AACA;IACI,qBAAqB;IACrB,8CAA8C;AAClD;;AAEA;IACI,0BAA0B,EAAE,sBAAsB,EAAE,uBAAuB;IAC3E,sBAAsB,EAAE,oBAAoB,EAAE,cAAc;AAChE;;AAEA;IACI,OAAO;IACP,YAAY;IACZ,YAAY;IACZ,uBAAuB;IACvB,wBAAwB;IACxB,2BAA2B;IAC3B,kCAAkC;IAClC,qBAAqB;IACrB,eAAe;IACf,cAAc;AAClB;AACA,qCAAqC,WAAW,EAAE;;AAElD;IACI,oBAAoB,EAAE,qBAAqB;IAC3C,0BAA0B,EAAE,sBAAsB,EAAE,uBAAuB,EAAE,2BAA2B;IACxG,4BAA4B,EAAE,cAAc;AAChD;AACA;IACI,0BAA0B,EAAE,sBAAsB,EAAE,uBAAuB,EAAE,sBAAsB,EAAE,oBAAoB;AAC7H;;AAEA;IACI,2BAA2B;IAC3B,gBAAgB,EAAE,eAAe;IACjC,gBAAgB,EAAE,kBAAkB;IACpC,kCAAkC,EAAE,6BAA6B;IACjE,qBAAqB;AACzB;;AAEA;;kDAEkD;AAClD;IACI,4BAA4B;IAC5B,wCAAwC;IACxC,2BAA2B;IAC3B,2BAA2B;IAC3B,6BAA6B;IAC7B,wBAAwB;IACxB,8BAA8B;IAC9B,oCAAoC;IACpC,oBAAoB;IACpB,yBAAyB;AAC7B;;AAEA;;IAEI,uBAAuB,EAAE,2BAA2B,EAAE,4BAA4B;IAClF,0BAA0B,EAAE,oBAAoB;IAChD,6BAA6B;IAC7B,0BAA0B,EAAE,2BAA2B;IACvD,+BAA+B,EAAE,4BAA4B;IAC7D,+BAA+B,EAAE,8BAA8B,EAAE,kCAAkC,EAAE,mBAAmB;IACxH,2BAA2B,EAAE,0BAA0B;IACvD,2CAA2C;AAC/C;AACA;;IAEI,0BAA0B,EAAE,sBAAsB,EAAE,uBAAuB,EAAE,2BAA2B;IACxG,oBAAoB,EAAE,yBAAyB;AACnD;;AAEA,oBAAoB;AACpB,wCAAwC,8BAA8B,EAAE,sBAAsB,EAAE,6CAA6C,EAAE;AAC/I,8CAA8C,8BAA8B,EAAE;;AAE9E,qCAAqC;AACrC,0CAA0C,4BAA4B,EAAE,mCAAmC,EAAE,8CAA8C,EAAE;AAC7J,gDAAgD,6CAA6C,EAAE;;AAE/F;;kDAEkD;AAClD;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,SAAS;IACT,6BAA6B;IAC7B,kBAAkB;IAClB,kCAAkC;IAClC,6BAA6B;IAC7B,2BAA2B;IAC3B,eAAe;IACf,eAAe;IACf,wDAAwD;AAC5D;AACA,sBAAsB,+BAA+B,EAAE,kCAAkC,EAAE;AAC3F,qBAAqB,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AACrF;IACI,0BAA0B,EAAE,sBAAsB,EAAE,uBAAuB,EAAE,0BAA0B;IACvG,mCAAmC,EAAE,oBAAoB;AAC7D;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,aAAa;IACb,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,yCAAyC;IACzC,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,OAAO;IACP,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,aAAa;AACjB","sourcesContent":["/* =====================================================\n   DATA EXPLORER DIALOG — BizMetry design system\n   -----------------------------------------------------\n   Header 68px · brand gradient · icon 30px (no box) · title 19/600 · subtitle 12px\n   Footer 68px · white · 2px #f0f0f0 top border\n   Buttons 36px · radius 4 · 13/600 · no uppercase, no lift\n   Tags: brand-soft (rgba(102,126,234,.12) / #5568d3) · amber (#fef3c7 / #92400e)\n   Text #2c3e50 / #555 / #888 · borders #e0e0e0 / #eef0f3\n   JetBrains Mono only for identifiers and raw values\n   ===================================================== */\n\n.data-explorer-dialog {\n    --de-gradient:     linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n    --de-primary:      #667eea;\n    --de-primary-dark: #5568d3;\n    --de-primary-soft: rgba(102, 126, 234, .12);\n    --de-primary-tint: rgba(102, 126, 234, .06);\n    --de-text:         #2c3e50;\n    --de-text-2:       #555;\n    --de-muted:        #888;\n    --de-faint:        #bbb;\n    --de-border:       #e0e0e0;\n    --de-border-soft:  #eef0f3;\n    --de-page:         #fafbfc;\n    --de-amber-bg:     #fef3c7;\n    --de-amber:        #92400e;\n    --de-danger:       #e53e3e;\n    --de-mono:         'JetBrains Mono', 'Fira Code', monospace;\n}\n\n/* ── Dialog shell ── */\n.data-explorer-dialog {\n    width: 1440px;\n    max-width: 98vw;\n    height: 90vh;\n    max-height: 90vh;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n}\n\n/* ── Toolbar ── */\n.de-toolbar {\n    background: var(--de-gradient) !important;\n    min-height: 68px !important;\n    max-height: 68px !important;\n    flex-shrink: 0 !important;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, .15) !important;\n}\n\n.de-toolbar .md-toolbar-tools {\n    height: 68px !important;\n    min-height: 68px !important;\n    padding: 0 16px 0 24px !important;\n    gap: 14px !important;\n    display: flex !important;\n    align-items: center !important;\n}\n\n/* Icon: plain white glyph, no tile around it */\n.de-toolbar-icon-wrap {\n    display: flex;\n    align-items: center;\n    flex-shrink: 0;\n}\n\n.de-toolbar-icon-wrap md-icon {\n    color: white !important;\n    font-size: 30px !important;\n    width: 30px !important;\n    height: 30px !important;\n    margin: 0 !important;\n}\n\n.de-toolbar-info {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n}\n\n.de-toolbar-title {\n    font-size: 19px;\n    font-weight: 600;\n    line-height: 1.2;\n    color: white;\n    letter-spacing: 0;\n}\n\n.de-toolbar-sub {\n    font-size: 12px;\n    color: rgba(255, 255, 255, .8);\n    display: flex;\n    align-items: center;\n    gap: 6px;\n}\n\n.de-toolbar-host { font-family: var(--de-mono); font-size: 11px; }\n\n.de-toolbar-sep { color: rgba(255, 255, 255, .45); }\n\n.de-toolbar-type {\n    background: rgba(255, 255, 255, .18);\n    color: white;\n    padding: 1px 7px;\n    border-radius: 4px;\n    font-size: 11px;\n    font-weight: 600;\n}\n\n/* Header chips: white-on-gradient, square-ish like the rest of the tags */\n.de-badge {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    padding: 4px 10px;\n    border-radius: 4px;\n    font-size: 12px;\n    font-weight: 600;\n    flex-shrink: 0;\n    white-space: nowrap;\n    background: rgba(255, 255, 255, .15);\n    color: white;\n    border: none;\n}\n\n.de-badge md-icon {\n    font-size: 15px !important;\n    width: 15px !important;\n    height: 15px !important;\n    margin: 0 !important;\n    color: rgba(255, 255, 255, .85) !important;\n}\n\n.de-badge-table {\n    font-family: var(--de-mono);\n    font-weight: 500;\n    max-width: 260px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.de-close-btn {\n    color: rgba(255, 255, 255, .8) !important;\n    margin: 0 !important;\n    width: 36px !important;\n    height: 36px !important;\n    min-width: 36px !important;\n    border-radius: 50% !important;\n}\n.de-close-btn:hover { background: rgba(255, 255, 255, .12) !important; color: white !important; }\n.de-close-btn md-icon { color: inherit !important; }\n\n/* ── Body layout ── */\n/* Angular Material sobrescribe md-dialog-content con display:block */\n.de-body {\n    flex: 1 !important;\n    min-height: 0 !important;\n    overflow: hidden !important;\n    padding: 0 !important;\n    display: flex !important;\n    flex-direction: row !important;\n    background: var(--de-page) !important;\n}\n\n/* ════════════════════════════════════════════════\n   LEFT PANEL — tree\n════════════════════════════════════════════════ */\n.de-left-panel {\n    width: 300px;\n    min-width: 260px;\n    max-width: 300px;\n    flex-shrink: 0;\n    background: #ffffff;\n    border-right: 1px solid var(--de-border);\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n    min-height: 0;\n}\n\n.de-panel-header {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 12px 14px 10px;\n    border-bottom: 1px solid var(--de-border-soft);\n    background: white;\n    font-size: 12px;\n    font-weight: 600;\n    color: var(--de-text-2);\n    text-transform: uppercase;\n    letter-spacing: .4px;\n    flex-shrink: 0;\n}\n\n.de-panel-header-icon {\n    font-size: 16px !important; width: 16px !important; height: 16px !important;\n    color: var(--de-primary) !important; margin: 0 !important;\n}\n\n.de-refresh-btn {\n    width: 28px !important;\n    height: 28px !important;\n    min-width: 28px !important;\n    min-height: 28px !important;\n    padding: 0 !important;\n    margin: 0 !important;\n    color: var(--de-muted) !important;\n}\n\n.de-refresh-btn md-icon {\n    font-size: 16px !important;\n    width: 16px !important;\n    height: 16px !important;\n    color: var(--de-muted) !important;\n}\n\n/* ── Search input ── */\n.de-tree-search {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    margin: 10px 12px;\n    padding: 2px 4px 2px 10px;\n    border: 1px solid var(--de-border);\n    border-radius: 4px;\n    background: white;\n    flex-shrink: 0;\n    transition: border-color .18s ease, box-shadow .18s ease;\n}\n.de-tree-search:focus-within { border-color: var(--de-primary); box-shadow: 0 0 0 3px rgba(102, 126, 234, .12); }\n\n.de-tree-search md-icon {\n    font-size: 16px !important;\n    width: 16px !important;\n    height: 16px !important;\n    color: var(--de-muted) !important;\n    margin: 0 !important;\n    flex-shrink: 0;\n}\n\n.de-tree-search input {\n    flex: 1;\n    height: 28px;\n    border: none;\n    outline: none;\n    font-size: 13px;\n    color: var(--de-text);\n    background: transparent;\n    min-width: 0;\n}\n\n.de-tree-search .de-tree-search-clear {\n    min-width: 24px !important; width: 24px !important; height: 24px !important; min-height: 24px !important;\n    padding: 0 !important; margin: 0 !important; line-height: 24px !important;\n}\n.de-tree-search .de-tree-search-clear md-icon { font-size: 14px !important; width: 14px !important; height: 14px !important; }\n\n.de-tree-search input::placeholder {\n    color: #aaa;\n}\n\n.de-tree-loading,\n.de-tree-error {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n    padding: 40px 16px;\n    color: var(--de-muted);\n    font-size: 13px;\n    text-align: center;\n}\n\n.de-tree-error { color: var(--de-danger); }\n\n.de-tree-error md-icon {\n    font-size: 36px !important;\n    width: 36px !important;\n    height: 36px !important;\n}\n\n.de-tree-error md-icon { color: var(--de-danger) !important; }\n\n/* ── Tree scroll area ── */\n.de-tree-scroll {\n    flex: 1;\n    min-height: 0;\n    overflow-y: auto;\n    overflow-x: hidden;\n}\n\n.de-tree-scroll::-webkit-scrollbar { width: 5px; }\n\n.de-tree-scroll::-webkit-scrollbar-thumb {\n    background: #e0e0e0;\n    border-radius: 3px;\n}\n\n.de-tree-scroll::-webkit-scrollbar-thumb:hover { background: #bdbdbd; }\n\n/* ── Schema rows ── */\n.de-schema-block { border-bottom: 1px solid var(--de-border-soft); }\n\n.de-schema-row {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    padding: 9px 10px 9px 8px;\n    cursor: pointer;\n    user-select: none;\n    transition: background 0.15s ease;\n}\n\n.de-schema-row:hover        { background: var(--de-primary-tint); }\n.de-schema-row-expanded     { background: var(--de-primary-tint); }\n\n.de-schema-name {\n    flex: 1;\n    font-size: 13px;\n    font-weight: 600;\n    color: var(--de-text);\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.de-schema-icon {\n    font-size: 16px !important;\n    width: 16px !important;\n    height: 16px !important;\n    color: var(--de-primary) !important;\n    flex-shrink: 0;\n}\n\n.de-table-count-badge {\n    background: var(--de-primary-soft);\n    color: var(--de-primary-dark);\n    font-size: 11px;\n    font-weight: 600;\n    padding: 1px 6px;\n    border-radius: 4px;\n    flex-shrink: 0;\n}\n\n/* ── Chevron ── */\n.de-chevron {\n    font-size: 18px !important;\n    width: 18px !important;\n    height: 18px !important;\n    color: var(--de-faint) !important;\n    flex-shrink: 0;\n    transition: transform 0.2s ease;\n}\n\n.de-chevron-sm {\n    font-size: 14px !important;\n    width: 14px !important;\n    height: 14px !important;\n}\n\n.de-chevron-open { transform: rotate(90deg); }\n\n/* ── Tables / attributes ── */\n.de-subtree-loading,\n.de-subtree-empty {\n    padding: 6px 12px 6px 44px;\n    font-size: 12px;\n    color: var(--de-muted);\n}\n\n.de-table-row {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    padding: 7px 10px 7px 18px;\n    cursor: pointer;\n    user-select: none;\n    transition: background 0.15s ease;\n}\n\n.de-table-row:hover { background: var(--de-primary-tint); }\n\n.de-table-row-selected {\n    background: var(--de-primary-soft) !important;\n    border-left: 3px solid var(--de-primary);\n    padding-left: 15px !important;\n}\n\n.de-table-expand-btn {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 18px;\n    min-width: 18px;\n    flex-shrink: 0;\n}\n\n.de-table-icon {\n    font-size: 15px !important;\n    width: 15px !important;\n    height: 15px !important;\n    color: var(--de-muted) !important;\n    flex-shrink: 0;\n    transition: color 0.15s;\n}\n\n.de-table-icon-selected { color: var(--de-primary) !important; }\n\n.de-table-name {\n    flex: 1;\n    font-size: 13px;\n    color: var(--de-text);\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.de-table-row-selected .de-table-name {\n    color: var(--de-primary-dark);\n    font-weight: 600;\n}\n\n.de-attr-row {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    padding: 4px 10px 4px 48px;\n    transition: background 0.12s;\n}\n\n.de-attr-row:hover { background: var(--de-page); }\n\n.de-attr-icon {\n    font-size: 13px !important;\n    width: 13px !important;\n    height: 13px !important;\n    flex-shrink: 0;\n}\n\n.de-attr-name {\n    font-size: 12px;\n    color: var(--de-text-2);\n    flex: 1;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    transition: opacity 0.15s, text-decoration 0.15s;\n}\n\n.de-attr-type {\n    font-size: 10px;\n    color: var(--de-muted);\n    font-family: var(--de-mono);\n    background: #f5f5f5;\n    padding: 1px 5px;\n    border-radius: 4px;\n    flex-shrink: 0;\n    max-width: 80px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    transition: opacity 0.15s;\n}\n\n/* PK: amber tag */\n.de-pk-badge {\n    font-size: 10px;\n    font-weight: 600;\n    color: var(--de-amber);\n    background: var(--de-amber-bg);\n    padding: 0 5px;\n    border-radius: 4px;\n    flex-shrink: 0;\n}\n\n/* ── Type icon colors ── */\n.de-type-num  { color: #1565c0 !important; }\n.de-type-str  { color: #2e7d32 !important; }\n.de-type-date { color: #6a1b9a !important; }\n.de-type-bool { color: #e65100 !important; }\n.de-type-json { color: #00695c !important; }\n.de-type-id   { color: #c62828 !important; }\n.de-type-bin  { color: #4e342e !important; }\n\n/* ════════════════════════════════════════════════\n   RIGHT PANEL — data viewer\n   min-height:0 es obligatorio en cada nivel de la\n   cadena flex para que justify-content:center funcione\n════════════════════════════════════════════════ */\n.de-right-panel {\n    flex: 1 !important;\n    min-width: 0 !important;\n    min-height: 0 !important;\n    display: flex !important;\n    flex-direction: column !important;\n    overflow: hidden !important;\n    background: var(--de-page);\n}\n\n/* Wrapper interno generado por ng-if=\"selectedTable\" */\n.de-right-panel > div {\n    flex: 1;\n    min-height: 0;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n}\n\n/* State icon (no table / no rows / no matches / error) */\n.de-state-icon {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 56px;\n    height: 56px;\n    border-radius: 50%;\n    background: var(--de-primary-soft);\n    margin-bottom: 4px;\n}\n\n.de-state-icon md-icon {\n    font-size: 28px !important;\n    width: 28px !important;\n    height: 28px !important;\n    color: var(--de-muted) !important;\n    margin: 0 !important;\n}\n\n.de-state-icon--error { background: rgba(229, 62, 62, .1); }\n.de-state-icon--error md-icon { color: var(--de-danger) !important; }\n\n.de-state-title { font-size: 15px; font-weight: 600; color: var(--de-text); }\n.de-state-sub   { font-size: 13px; color: var(--de-muted); }\n\n/* ── Data wrapper & content area ── */\n.de-data-wrapper,\n.de-data-content-area {\n    flex: 1 !important;\n    min-width: 0 !important;\n    min-height: 0 !important;\n    display: flex !important;\n    flex-direction: column !important;\n    overflow: hidden !important;\n}\n\n/* ── Data header bar ── */\n.de-data-header {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 10px 16px;\n    background: white;\n    border-bottom: 1px solid var(--de-border-soft);\n    flex-shrink: 0 !important;\n    flex-wrap: wrap;\n}\n\n.de-data-breadcrumb {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n}\n\n.de-bc-icon { font-size: 16px !important; width: 16px !important; height: 16px !important; color: var(--de-primary) !important; margin: 0 !important; }\n.de-bc-sep  { font-size: 14px !important; width: 14px !important; height: 14px !important; color: var(--de-faint) !important; margin: 0 !important; }\n\n.de-bc-schema {\n    font-family: var(--de-mono);\n    font-size: 12px;\n    color: var(--de-primary-dark);\n    font-weight: 500;\n}\n\n.de-bc-table {\n    font-family: var(--de-mono);\n    font-size: 13px;\n    font-weight: 600;\n    color: var(--de-text);\n}\n\n.de-pagination-info {\n    font-size: 12px;\n    color: var(--de-muted);\n    white-space: nowrap;\n    flex-shrink: 0;\n}\n\n.de-page-size-wrap {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    flex-shrink: 0;\n}\n\n.de-page-size-label {\n    font-size: 12px;\n    color: var(--de-muted);\n}\n\n.de-page-size-select {\n    border: 1px solid var(--de-border);\n    border-radius: 4px;\n    padding: 3px 7px;\n    font-size: 12px;\n    color: var(--de-text);\n    background: white;\n    cursor: pointer;\n    outline: none;\n}\n\n.de-page-size-select:focus { border-color: var(--de-primary); }\n\n.de-pagination-btns {\n    display: flex;\n    align-items: center;\n    gap: 2px;\n    flex-shrink: 0;\n}\n\n.de-pag-btn {\n    width: 30px !important;\n    height: 30px !important;\n    min-width: 30px !important;\n    min-height: 30px !important;\n    padding: 0 !important;\n    margin: 0 !important;\n    color: var(--de-text-2) !important;\n    border-radius: 4px !important;\n    line-height: 30px !important;\n    display: inline-flex !important;\n    align-items: center !important;\n    justify-content: center !important;\n}\n\n.de-pag-btn md-icon {\n    font-size: 18px !important;\n    width: 18px !important;\n    height: 18px !important;\n    line-height: 18px !important;\n    display: flex !important;\n    align-items: center !important;\n    justify-content: center !important;\n}\n\n.de-pag-btn[disabled]            { opacity: 0.35 !important; }\n.de-pag-btn:not([disabled]):hover { background: var(--de-primary-tint) !important; color: var(--de-primary) !important; }\n\n.de-page-num {\n    font-size: 12px;\n    color: var(--de-text-2);\n    font-weight: 600;\n    padding: 0 8px;\n    white-space: nowrap;\n}\n\n/* ── Loading / error / empty data states ── */\n.de-data-loading,\n.de-data-err,\n.de-data-no-rows {\n    flex: 1 !important;\n    min-width: 0 !important;\n    min-height: 0 !important;\n    display: flex !important;\n    flex-direction: column !important;\n    align-items: center !important;\n    justify-content: center !important;\n    text-align: center !important;\n    padding: 40px !important;\n    gap: 10px;\n    font-size: 13px;\n    color: var(--de-muted);\n}\n\n.de-data-err { gap: 10px; }\n\n/* ── Data table wrapper ── */\n.de-table-scroll-wrap {\n    flex: 1 !important;\n    min-width: 0 !important;\n    min-height: 0 !important;\n    overflow: auto;\n}\n\n.de-table-scroll-wrap::-webkit-scrollbar        { width: 8px; height: 8px; }\n.de-table-scroll-wrap::-webkit-scrollbar-thumb  { background: var(--de-border); border-radius: 4px; }\n.de-table-scroll-wrap::-webkit-scrollbar-thumb:hover { background: var(--de-faint); }\n.de-table-scroll-wrap::-webkit-scrollbar-corner { background: transparent; }\n\n/* ── Data table ── */\n.de-data-table {\n    width: max-content;\n    min-width: 100%;\n    border-collapse: collapse;\n    font-size: 13px;\n}\n\n.de-data-table thead {\n    position: sticky;\n    top: 0;\n    z-index: 10;\n}\n\n.de-row-num-th {\n    position: sticky;\n    left: 0;\n    z-index: 11;\n    width: 52px;\n    min-width: 52px;\n    padding: 10px 8px;\n    text-align: right;\n    font-size: 11px;\n    font-weight: 600;\n    color: var(--de-muted);\n    background: #f5f6f8;\n    border-bottom: 1px solid var(--de-border);\n    border-right: 1px solid var(--de-border-soft);\n    user-select: none;\n}\n\n.de-col-th {\n    padding: 10px 14px !important;\n    background: #f5f6f8 !important;\n    border-bottom: 1px solid var(--de-border) !important;\n    border-right: 1px solid var(--de-border-soft) !important;\n    font-size: 12px !important;\n    font-weight: 600 !important;\n    color: var(--de-text-2) !important;\n    white-space: nowrap !important;\n    user-select: none !important;\n    text-align: left !important;\n    vertical-align: middle !important;\n}\n\n.de-col-th-inner {\n    display: inline-flex !important;\n    align-items: center !important;\n    justify-content: flex-start !important;\n    gap: 6px !important;\n    width: auto !important;\n    min-width: 0 !important;\n    margin: 0 !important;\n    padding: 0 !important;\n    box-sizing: border-box !important;\n    text-align: left !important;\n    line-height: 1.2 !important;\n}\n\n.de-col-th-inner span {\n    text-align: left !important;\n}\n\n.de-col-type-icon {\n    font-size: 13px !important;\n    width: 13px !important;\n    height: 13px !important;\n    flex: 0 0 auto !important;\n    margin-right: 2px !important;\n}\n\n/* ── Rows ── */\n.de-data-row { transition: background 0.1s ease; }\n.de-data-row:hover { background: var(--de-primary-tint) !important; }\n.de-row-even { background: var(--de-page); }\n\n.de-row-num-td {\n    position: sticky;\n    left: 0;\n    z-index: 5;\n    width: 52px;\n    min-width: 52px;\n    padding: 8px;\n    text-align: right;\n    font-size: 11px;\n    color: var(--de-faint);\n    background: inherit;\n    border-right: 1px solid var(--de-border-soft);\n    border-bottom: 1px solid var(--de-border-soft);\n    font-family: var(--de-mono);\n}\n\n.de-data-td {\n    padding: 10px 14px !important;\n    text-align: left !important;\n    vertical-align: middle !important;\n    border-bottom: 1px solid var(--de-border-soft);\n    border-right: 1px solid var(--de-border-soft);\n    max-width: 320px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n/* ── Cell value types ── */\n.de-null-val {\n    color: var(--de-faint);\n    font-size: 11px;\n    font-family: var(--de-mono);\n}\n\n.de-cell-val { color: var(--de-text); }\n\n.de-val-num {\n    color: #1565c0;\n    font-family: var(--de-mono);\n    font-size: 12px;\n}\n\n.de-val-id {\n    color: var(--de-primary-dark);\n    font-family: var(--de-mono);\n    font-size: 11px;\n    background: var(--de-primary-soft);\n    padding: 1px 5px;\n    border-radius: 4px;\n}\n\n.de-val-date {\n    color: #4a148c;\n    font-family: var(--de-mono);\n    font-size: 12px;\n}\n\n.de-val-bool {\n    color: var(--de-amber);\n    font-weight: 600;\n    font-size: 12px;\n}\n\n.de-val-json {\n    color: #00695c;\n    font-family: var(--de-mono);\n    font-size: 11px;\n}\n\n/* ── Spinners ── */\n.de-spinner circle { stroke: var(--de-primary) !important; }\n\n.de-inline-spinner {\n    flex-shrink: 0;\n    margin-left: auto;\n}\n\n.de-inline-spinner circle { stroke: var(--de-muted) !important; }\n\n.de-spin { animation: de-spin-anim 0.8s linear infinite; }\n\n/* ── Explorer action button (datasource table) ── */\n.action-icon-explorer { color: var(--de-primary, #667eea) !important; }\n\n/* ── Animations ── */\n@keyframes de-spin-anim {\n    from { transform: rotate(0deg); }\n    to   { transform: rotate(360deg); }\n}\n\n.de-table-expand-btn .de-chevron {\n    width: 14px !important;\n    height: 14px !important;\n    display: flex !important;\n    align-items: center;\n    justify-content: center;\n}\n\n.de-right-panel {\n    display: flex !important;\n    flex-direction: column !important;\n    flex: 1 !important;\n    min-height: 0 !important;\n}\n\n.de-data-wrapper {\n    display: flex !important;\n    flex-direction: column !important;\n    flex: 1 !important;\n    min-height: 0 !important;\n}\n\n.de-data-content-area {\n    display: flex !important;\n    flex-direction: column !important;\n    flex: 1 !important;\n    min-height: 0 !important;\n}\n\n/* ════════════════════════════════════════════════\n   COLUMN VISIBILITY CHECKBOXES\n════════════════════════════════════════════════ */\n\n/* Checkbox de visibilidad en cada fila de atributo */\n.de-attr-checkbox {\n    width: 13px;\n    height: 13px;\n    min-width: 13px;\n    cursor: pointer;\n    accent-color: var(--de-primary);\n    flex-shrink: 0;\n    margin: 0;\n}\n\n/* Atributo oculto → tachado y opaco */\n.de-attr-row-hidden .de-attr-name {\n    opacity: 0.38;\n    text-decoration: line-through;\n}\n\n.de-attr-row-hidden .de-attr-type,\n.de-attr-row-hidden .de-attr-icon,\n.de-attr-row-hidden .de-pk-badge {\n    opacity: 0.35;\n}\n\n/* Botón toggle-all en la fila de la tabla */\n.de-col-toggle-btn {\n    width: 20px !important;\n    height: 20px !important;\n    min-width: 20px !important;\n    min-height: 20px !important;\n    padding: 0 !important;\n    margin: 0 0 0 2px !important;\n    flex-shrink: 0;\n    color: var(--de-faint) !important;\n    border-radius: 4px !important;\n    line-height: 20px !important;\n    display: inline-flex !important;\n    align-items: center !important;\n    justify-content: center !important;\n}\n\n.de-col-toggle-btn:hover {\n    background: var(--de-primary-soft) !important;\n    color: var(--de-primary) !important;\n}\n\n.de-col-toggle-wrap { display: inline-flex; align-items: center; gap: 3px; margin-left: 2px; flex-shrink: 0; }\n\n.de-col-toggle-btn md-icon {\n    font-size: 13px !important;\n    width: 13px !important;\n    height: 13px !important;\n}\n\n/* Badge \"N/M cols\" cuando hay columnas ocultas */\n/* \"N/M\" visible columns: amber while some are hidden, brand-soft when all are shown */\n.de-col-vis-badge {\n    font-size: 10px;\n    font-weight: 600;\n    padding: 1px 5px;\n    border-radius: 4px;\n    flex-shrink: 0;\n    white-space: nowrap;\n    background: var(--de-amber-bg);\n    color: var(--de-amber);\n}\n\n.de-col-vis-badge-full {\n    background: var(--de-primary-soft);\n    color: var(--de-primary-dark);\n}\n/* ════════════════════════════════════════════════\n   DATA SEARCH (server-side)\n   Own de-* classes: agents-tab.css defines unscoped .search-icon / .search-input\n════════════════════════════════════════════════ */\n.de-data-search-bar {\n    padding: 10px 16px;\n    background: white;\n    border-bottom: 1px solid var(--de-border-soft);\n    flex-shrink: 0 !important;\n}\n\n.de-data-search {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    max-width: 520px;\n    padding: 4px 8px 4px 12px;\n    background: white;\n    border: 1px solid #e0e0e0;\n    border-radius: 4px;\n    transition: border-color .18s ease, box-shadow .18s ease;\n}\n.de-data-search:focus-within {\n    border-color: #667eea;\n    box-shadow: 0 0 0 3px rgba(102, 126, 234, .12);\n}\n\n.de-data-search-icon {\n    font-size: 18px !important; width: 18px !important; height: 18px !important;\n    color: #888 !important; margin: 0 !important; flex-shrink: 0;\n}\n\n.de-data-search .de-data-search-input {\n    flex: 1;\n    min-width: 0;\n    height: 26px;\n    border: none !important;\n    outline: none !important;\n    box-shadow: none !important;\n    background: transparent !important;\n    padding: 0 !important;\n    font-size: 13px;\n    color: #2c3e50;\n}\n.de-data-search-input::placeholder { color: #aaa; }\n\n.de-data-search .de-data-search-clear {\n    margin: 0 !important; padding: 0 !important;\n    min-width: 24px !important; width: 24px !important; height: 24px !important; min-height: 24px !important;\n    line-height: 24px !important; flex-shrink: 0;\n}\n.de-data-search .de-data-search-clear md-icon {\n    font-size: 16px !important; width: 16px !important; height: 16px !important; color: #888 !important; margin: 0 !important;\n}\n\n.de-no-match-term {\n    font-family: var(--de-mono);\n    font-weight: 500; font-size: 13px;\n    padding: 2px 8px; border-radius: 4px;\n    background: var(--de-primary-soft); color: var(--de-primary-dark);\n    word-break: break-all;\n}\n\n/* ════════════════════════════════════════════════\n   FOOTER + BUTTONS (36px · radius 4 · 13/600)\n════════════════════════════════════════════════ */\n.data-explorer-dialog .de-footer {\n    background: white !important;\n    border-top: 2px solid #f0f0f0 !important;\n    box-shadow: none !important;\n    min-height: 68px !important;\n    padding: 14px 24px !important;\n    display: flex !important;\n    align-items: center !important;\n    justify-content: flex-end !important;\n    gap: 12px !important;\n    flex-shrink: 0 !important;\n}\n\n.data-explorer-dialog .de-btn-neutral,\n.data-explorer-dialog .de-btn-secondary {\n    height: 36px !important; min-height: 36px !important; line-height: 36px !important;\n    padding: 0 18px !important; margin: 0 !important;\n    border-radius: 4px !important;\n    font-size: 13px !important; font-weight: 600 !important;\n    text-transform: none !important; letter-spacing: 0 !important;\n    display: inline-flex !important; align-items: center !important; justify-content: center !important; gap: 6px !important;\n    box-shadow: none !important; transform: none !important;\n    transition: background .18s ease !important;\n}\n.data-explorer-dialog .de-btn-neutral md-icon,\n.data-explorer-dialog .de-btn-secondary md-icon {\n    font-size: 18px !important; width: 18px !important; height: 18px !important; min-height: 18px !important;\n    margin: 0 !important; color: inherit !important;\n}\n\n/* neutral — Close */\n.data-explorer-dialog .de-btn-neutral { background: #f5f5f5 !important; color: #666 !important; border: 1px solid var(--de-border) !important; }\n.data-explorer-dialog .de-btn-neutral:hover { background: #eaeaea !important; }\n\n/* secondary — Retry / Clear search */\n.data-explorer-dialog .de-btn-secondary { background: white !important; color: var(--de-primary) !important; border: 2px solid var(--de-primary) !important; }\n.data-explorer-dialog .de-btn-secondary:hover { background: var(--de-primary-tint) !important; }\n\n/* ════════════════════════════════════════════════\n   JSON CELLS → biz-json-viewer\n════════════════════════════════════════════════ */\n.de-json-cell {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    max-width: 290px;\n    height: 24px;\n    padding: 0 8px;\n    margin: 0;\n    border: 1px solid transparent;\n    border-radius: 4px;\n    background: var(--de-primary-tint);\n    color: var(--de-primary-dark);\n    font-family: var(--de-mono);\n    font-size: 11px;\n    cursor: pointer;\n    transition: border-color .18s ease, background .18s ease;\n}\n.de-json-cell:hover { border-color: var(--de-primary); background: var(--de-primary-soft); }\n.de-json-cell span { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n.de-json-cell md-icon {\n    font-size: 15px !important; width: 15px !important; height: 15px !important; min-width: 15px !important;\n    color: var(--de-primary) !important; margin: 0 !important;\n}\n\n.de-json-backdrop {\n    position: fixed;\n    inset: 0;\n    z-index: 9999;\n    background: rgba(0, 0, 0, .55);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n.de-json-frame {\n    width: 90vw;\n    max-width: 860px;\n    height: 80vh;\n    max-height: 80vh;\n    border-radius: 8px;\n    overflow: hidden;\n    background: white;\n    box-shadow: 0 24px 48px rgba(0, 0, 0, .4);\n    display: flex;\n    flex-direction: column;\n}\n.de-json-frame > biz-json-viewer {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n    min-height: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
